import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { PlycaDataService } from '../../../services/plyca.service';
import { FileDetailsDTO, TemplateDTO } from '../../api/plyca-dtos';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { Configuration } from '../../conf/app.constants';
import { ServiceLocator } from '../../ServiceLocator';
import { AppState } from '../../store/AppState';
import { UIService } from '../../ui.service';
import { DocumentService } from '../document.service';
import { map, flatMap, catchError, finalize, tap, switchMap } from 'rxjs/operators';
import { BaseDirectiveObject } from '../../components/common/base-directive-object';


@Injectable()
export class TemplateService extends BaseDirectiveObject {

  translate: TranslateService;
  waitService: WaitLoadingService;
  documentService: DocumentService;

  constructor(
    public plycaService: PlycaDataService,
    protected store: Store<AppState>,
    public uiService: UIService,
    protected configuration: Configuration
  ) {
    super();
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);
    this.documentService = ServiceLocator.injector.get(DocumentService);
  }


  public generaTemplateByDocumentClassName(dossierId: string, documentClassName: string, division: string, nameTemplateGenerated?: string): Observable<any> {



    let templates: TemplateDTO[];
    let template: TemplateDTO;
    return this.loadTemplateByDocumentClassName(dossierId, documentClassName, division).pipe(
      switchMap((param: any) => {
        if (param != null && param.content) {
          templates = param.content;
          template = templates[0];
          return this.generateTemplateByDocumentClassName(template, dossierId, documentClassName, division, nameTemplateGenerated);
        } else {
          this.uiService.showMessage('No se ha enontrado plantilla para el expediente ' + dossierId + ' con division ' + division + ' y documento  ' + documentClassName);
          return of({});
        }
      })
    );
  }


  public generaTemplateByName(nameTempate: string, dossierId: string, division: string, nameTemplateGenerated?: string): Observable<any> {
    let templates: TemplateDTO[];
    let template: TemplateDTO;
    return this.loadTemplateByName(nameTempate).pipe(
      switchMap((param: any) => {
        if (param != null && param.content) {
          templates = param.content;
          template = templates[0];
          return this.generateTemplateByDocumentClassId(template, dossierId, template.documentClass.identifier, division, nameTemplateGenerated);
        } else {
          this.uiService.showMessage('No se ha enontrado plantilla para el expediente ' + dossierId + ' con division ' + division + ' y plantilla  ' + name);
          return of({});
        }
      })
    );
  }



  private generateTemplateByDocumentClassName(template: TemplateDTO, dossierId: string,
    documentClassName: string, division: string, nameTemplateGenerated?: string): Observable<any> {
    let observable: Observable<any>;

    let params = 'division=' + division + '&' + 'documentClassName=' + documentClassName + '&' + 'projectEntityId=' + dossierId;

    return this.generateTemplateByParams(template, params, (nameTemplateGenerated != null ? nameTemplateGenerated : documentClassName));
  }


  private generateTemplateByDocumentClassId(template: TemplateDTO, dossierId: string,
    documentClassId: string, division: string, nameTemplateGenerated?: string): Observable<any> {
    let observable: Observable<any>;

    let params = 'division=' + division + '&' + 'documentClassId=' + documentClassId + '&' + 'projectEntityId=' + dossierId;

    return this.generateTemplateByParams(template, params, (nameTemplateGenerated != null ? nameTemplateGenerated : documentClassId));
  }

  private generateTemplateByParams(template: TemplateDTO, params: string, name: string): Observable<any> {
    let observable: Observable<any>;


    observable = this.plycaService.generateTemplateByDocumentClass(
      template,
      params
    );

    return observable.pipe(
      tap((fileDetails: FileDetailsDTO) => {
        if (fileDetails.name) {
          fileDetails.name = (name != null ? name : fileDetails.name) + fileDetails.name.substring(fileDetails.name.indexOf('.'));
        }
        this.documentService.downloadEmbedded(fileDetails);
      }),
      catchError(err => {
        //this.uiService.showMessage('No se ha generado la plantilla por el siguiente motivo ');
        return throwError(err);
      })
    );
  }


  private loadTemplateByDocumentClassId(dossierId: string, documentClassId: string, division: string): Observable<any> {
    return this.plycaService.findTemplatesByDocument(
      documentClassId,
      dossierId,
      division
    );
  }

  private loadTemplateByDocumentClassName(dossierId: string, documentClassName: string, division: string): Observable<any> {
    return this.plycaService.findTemplatesByDocumentClassName(
      documentClassName,
      dossierId,
      division
    );
  }

  private loadTemplateByName(name: string): Observable<any> {
    return this.plycaService.findTemplateByName(
      name
    );
  }
}